class Road {
  constructor(row, column, roundResults) {
      this.row = row;
      this.column = column;
      this.roundResults = roundResults;
      if (!Number.isInteger(row) ||
          !Number.isInteger(column) ||
          row < 0 ||
          column < 0) {
          throw new Error('Row/Column must be positive integer');
      }
  }
  get rowCount() {
      return this.row;
  }
  get columnCount() {
      return this.column;
  }
  getItem(rowIndex, columnIndex) {
      return this.array[rowIndex][columnIndex];
  }
  forEach(itemHandler) {
      for (let rowIndex = 0; rowIndex < this.row; rowIndex += 1) {
          for (let columnIndex = 0; columnIndex < this.column; columnIndex += 1) {
              itemHandler(this.array[rowIndex][columnIndex], rowIndex, columnIndex);
          }
      }
  }
}

export default Road;
